const SidebarStepEnum = Object.freeze({
  OVERVIEW: 0,
  TABS: 1,
  INSIGHTS: 2,
  INTEGRATIONS: 3,
  SAFETY: 4,
  STYLING: 5,
  KNOWLEDGE: 6,
  PERSONALITY: 7,
  SET_UP: 8,
  POWER_UPS: 9,
  REALTIME_VOICE: 10
});

export { SidebarStepEnum };
